<template>
  <div>
    <b-card
      header="Template"
      header-tag="h4"
      header-bg-variant="white"
      class="mt-3"
    >
      <b-container>
        <b-form-group
          label="Template"
          label-cols-lg="3"
        >
          <b-form-select
            v-model="template_id"
            @change="templateChanged"
            ref="template_selector"
            >
            <option disabled hidden value="">Choose a template...</option>
            <option
              v-for="template in templates"
              :key="template._id"
              :value="template._id"
            >{{ template.name }}</option>
          </b-form-select>
          <b-form-text>Select a base template as a starting point for customizing</b-form-text>
        </b-form-group>
      </b-container>
    </b-card>

    <b-card
      header="Editor"
      header-tag="h4"
      header-bg-variant="white"
      class="mt-3"
    >
      <div v-if="stage.template_document">
        <template-editor></template-editor>
      </div>

      <b-alert show v-if="!stage.template_document">Please select a base template above</b-alert>
    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import TemplateEditor from '@/components/TemplateEditor'
import serializer from '@/components/LayoutEditor/serializer'
import store from '@/store'

export default {
  components: {
    TemplateEditor
  },

  async beforeRouteEnter(to, from, next) {
    store.dispatch('stages/updateStageHasChanges', false)

    await store.dispatch('templates/fetchAll', true)

    // TODO: maybe make this an email action to reset everything
    const stage = store.state.stages.stage
    store.commit('emails/updateDocument', stage.template_document)
    store.commit('emails/updatePreviewHtml', stage.template_html)
    store.commit('emails/updateSubject', stage.email_subject)
    store.commit('emails/updatePreviewSubject', stage.email_subject)
    store.commit('emails/resetResource')

    next()
  },

  beforeRouteLeave(to, from, next) {
    if (this.stageHasChanges) {
      next(confirm('Are you sure you want to leave? You may have unsaved changes.'))
    } else {
      next()
    }
  },

  watch: {
    document: {
      handler(val) {
        this.updateStageHasChanges(true)

        // Keep stage doc and rendered html sync'd with emails module
        this.updateAttribute({ attribute: 'template_document', value: val })
        if(this.stage.rawMode)
          this.updateAttribute({ attribute: 'template_html', value: this.stage.rawModeContent })
        else
          this.updateAttribute({ attribute: 'template_html', value: val.render() })
      },
      deep: true
    }
  },

  computed: {
    ...mapState('emails', [
      'document',
      'previewHtml'
    ]),

    ...mapState('templates', [
      'templates'
    ]),

    ...mapState('stages', [
      'stage',
      'stageHasChanges'
    ]),

    template_id: {
      get() { return this.$store.state.stages.stage.template_id },
      set(value) { this.updateAttribute({ attribute: 'template_id', value }) }
    }
  },

  methods: {
    ...mapActions('stages', [
      'updateAttribute',
      'updateStageHasChanges'
    ]),

    ...mapActions('emails', [
      'preview'
    ]),

    ...mapMutations('emails', [
      'updateDocument',
      'updateSubject'
    ]),
    ...mapMutations('templates',['updateTemplate']),

    templateChanged(templateId) {
      const template = this.templates.find(template => template._id === templateId)
      const doc = serializer.revive(template.document)
      this.updateTemplate(template)
      // update current stage
      this.updateAttribute({ attribute: 'template_id', value: templateId })
      this.updateAttribute({ attribute: 'template_document', value: doc })
      if(template.rawMode){
        this.updateAttribute({ attribute: 'template_html', value: template.rawModeContent })
        this.updateAttribute({ attribute: 'rawModeContent', value: template.rawModeContent })
        this.updateAttribute({ attribute: 'rawMode', value: template.rawMode })
      } else {
        this.updateAttribute({ attribute: 'template_html', value: doc.render() })
      }


      // update template editor
      this.updateDocument(doc)
      this.updateSubject(this.stage.email_subject)

      this.preview()
    }
  }
}
</script>
